<template>
    <div class="navbar fixed-top navhead py-3" id="navhead">
        <div class="container">
            <div>
            </div>
            <div class="navbar-right">
                <div class=" mobile mr-3">
                    <a v-scroll-to="'#home'">Home</a>
                </div>
                <div class="mr-3">
                    <a v-scroll-to="'#work'">Work</a>
                </div>
                <div class="mr-3">
                    <a v-scroll-to="'#projects'">Projects</a>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    methods: {
        shrink_(){
            this.$nextTick(function(){
                window.addEventListener("scroll", function(){
                var navbar = document.getElementById("navhead")
                var nav_classes = navbar.classList
                if(document.documentElement.scrollTop >= 80) {
                    if (nav_classes.contains("shrink") === false) {
                    nav_classes.toggle("shrink");
                    }
                }
                else {
                    if (nav_classes.contains("shrink") === true) {
                    nav_classes.toggle("shrink");
                    }
                }
                })
            })
        }
    },
    mounted(){
        this.shrink_()
    }
}
</script>

<style scoped>
  .navbar{
    display: flex;
    justify-content: space-between;
    background-color:#151515
  }
  .navbar-right{
    display: flex;
  }
    @media only screen and (min-width: 768px) {
        .navbar{
            width: 50%;
        }
    }
</style>